import { gql, useQuery } from "@apollo/client";

export function useGetPolicy(_id: string) {
  return useQuery(
    gql`
        query getPolicy($_id: MongoID!) {
            company_policy(_id: $_id) {
                _id
                name
                policy_file_name
                policy_meta_data
            }
        }
        `,
        {
            variables: { _id },
            fetchPolicy : 'network-only'
        }
    );
}

